var map = {
	"./Flag_of_Azerbaijan.svg": 2431,
	"./ONT-OIAA-logo.png": 2432,
	"./Partly-Cloudy.png": 947,
	"./americanFlag.png": 2433,
	"./feed.jpg": 2434,
	"./franceFlag.png": 2435,
	"./germanFlag.png": 2436,
	"./portugalFlag.png": 2437,
	"./russianFlag.png": 2438,
	"./spainFlag.png": 2439,
	"./todo-assignment.svg": 2440,
	"./user.svg": 968
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2430;